import React, { Component } from "react";
import {  Modal, Form, Comment, Button, Segment, Feed } from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import { formatDateTime } from "../libs/sharedFunctions";
import './Comments.css';
import config from "../config";
import UserAvatar from './UserAvatar.js';


export default class Comments extends Component {
  constructor(props) {
    super(props);
    this.state={comments: [], commentsLoaded: false, newcomment: ''};

  }

  loadComments=(entityname, entityinstanceid)=>{
    //get function definition    
    this.setState({ eventLoaded: false})
    invokeApig({path: "/api/" + entityname + "s/" + entityinstanceid + "/comments", method: "GET",  body: null}).then((result)=>
    {
      this.setState({comments: result.data, commentsLoaded: true})
    })
  }

  async componentDidMount() {
    this.loadComments(this.props.entityname, this.props.entityinstanceid)
  }

  async componentWillReceiveProps(nextProps) {
  
    if (!(nextProps.entityname === this.props.entityname && nextProps.entityinstanceid===this.props.entityinstanceid)) 
    {
      this.loadComments(nextProps.entityname, nextProps.entityinstanceid);
    } 
  }


  addComment()
  {
    invokeApig({path: "/api/" + this.props.entityname + "s/" + this.props.entityinstanceid + "/comments", method: "POST",  body: {text: this.state.newcomment}}).then((result)=>
    {
      this.loadComments(this.props.entityname, this.props.entityinstanceid)
      this.setState({newcomment: ''})
    })
  }

  render() {
    return (
    <div>

      <Feed> 
      {this.state.comments.map((comment)=>
        <Feed.Event>
        <Feed.Label><UserAvatar commentuserid={comment.userid} stage={config.stage} username={comment.username} userid={this.props.userid}/></Feed.Label>
          <Feed.Content>
          <Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>
            <Feed.User style={{color: this.props.darkmode ? "white": "black"}}>{comment.username}</Feed.User>
            <Feed.Date style={{color: this.props.darkmode ? "white": "black"}}>  
              <div>{formatDateTime(new Date(comment.datetime))}</div> 
            </Feed.Date>
            </Feed.Summary>
            <Feed.Extra text style={{color: this.props.darkmode ? "white": "black"}}>{comment.text}</Feed.Extra>
          </Feed.Content>
        </Feed.Event>
      )}
      </Feed>
      <Form reply>
    <Form.TextArea rows={2} value={this.state.newcomment} onChange={(event, data)=>{this.setState({newcomment: data.value})}}/>
    <Button className='seaglasssecondarybutton' disabled={this.state.newcomment.length===0} onClick={()=>{this.addComment()}} content='Add Comment' labelPosition='left' icon='edit' primary />
    </Form>
    </div>         
    )
  }
}